import { TS_06_DEACTIVATION_DATE, WasteType } from "./constants";
import { StreamItem, WasteItem } from "../types/waste";
import { TS_06_CODES } from "./TS-06-codes";

export const yearData = [
  { year: 2024, coefficient: 66.17, type: WasteType.NOT_DANGEROUS },
  { year: 2025, coefficient: 66.17, type: WasteType.NOT_DANGEROUS },
  { year: 2026, coefficient: 67.67, type: WasteType.NOT_DANGEROUS },
  { year: 2027, coefficient: 67.67, type: WasteType.NOT_DANGEROUS },
  { year: 2024, coefficient: 304.43, type: WasteType.DANGEROUS },
  { year: 2025, coefficient: 304.43, type: WasteType.DANGEROUS },
  { year: 2026, coefficient: 311.16, type: WasteType.DANGEROUS },
  { year: 2027, coefficient: 311.16, type: WasteType.DANGEROUS },
  {
    year: 2024,
    coefficient: { s1: 2.95, s2: 0.74 },
    type: WasteType.DUMP_NOT_DANGEROUS
  },
  {
    year: 2025,
    coefficient: { s1: 2.95, s2: 0.74 },
    type: WasteType.DUMP_NOT_DANGEROUS
  },
  {
    year: 2026,
    coefficient: { s1: 3.02, s2: 0.76 },
    type: WasteType.DUMP_NOT_DANGEROUS
  },
  {
    year: 2027,
    coefficient: { s1: 3.02, s2: 0.76 },
    type: WasteType.DUMP_NOT_DANGEROUS
  },
  { year: 2024, coefficient: { s1: 8.65, s2: 2.1 }, type: WasteType.DUMP_DANGEROUS },
  { year: 2025, coefficient: { s1: 8.65, s2: 2.1 }, type: WasteType.DUMP_DANGEROUS },
  { year: 2026, coefficient: { s1: 8.87, s2: 2.15 }, type: WasteType.DUMP_DANGEROUS },
  { year: 2027, coefficient: { s1: 8.87, s2: 2.15 }, type: WasteType.DUMP_DANGEROUS },
  { year: 2024, coefficient: 0.74, type: WasteType.DUMP_INERT },
  { year: 2025, coefficient: 0.74, type: WasteType.DUMP_INERT },
  { year: 2026, coefficient: 0.76, type: WasteType.DUMP_INERT },
  { year: 2027, coefficient: 0.76, type: WasteType.DUMP_INERT },
  {
    year: 2024,
    coefficient: { s1: 0.162, s2: 0.001 },
    type: WasteType.DUMP_PHOSPHOGYPSUM
  },
  {
    year: 2025,
    coefficient: { s1: 0.162, s2: 0.001 },
    type: WasteType.DUMP_PHOSPHOGYPSUM
  },
  {
    year: 2026,
    coefficient: { s1: 0.165, s2: 0.001 },
    type: WasteType.DUMP_PHOSPHOGYPSUM
  },
  {
    year: 2027,
    coefficient: { s1: 0.165, s2: 0.001 },
    type: WasteType.DUMP_PHOSPHOGYPSUM
  }
];

export const stream: StreamItem[] = [
  { id: "0122", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0124", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0141", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0211", R: 1, D: 6.53, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0212", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0213", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0214", R: 0.15, D: 15.3, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0231", R: 0.15, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0311", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0313", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0314", R: 0.15, D: 15.3, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0321", R: 0.15, D: 15.3, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0331", R: 0.15, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0521", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0522", R: 0.71, D: 15.3, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0611", R: 0.01, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0623", R: 0.01, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0624", R: 0.01, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0625", R: 0.01, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0626", R: 0.01, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0631", R: 0.01, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0632", R: 0.01, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0711", R: 0.15, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0712", R: 0.15, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0721", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0723", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0731", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0741", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0742", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0751", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0752", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0753", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0761", R: 0.15, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0762", R: 0.15, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0763", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0812", R: 0.01, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0823", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0841", R: 0.01, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0843", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0911", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0912", R: 0.3, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0921", R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0922", R: 0.3, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "0931", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1011, R: 0.3, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1012, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1021, R: 0.15, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1022, R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: "1032", R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  {
    id: "1032 (taikoma tik atliekų kodui 19 12 10)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.NOT_DANGEROUS
  },
  {
    id: "1032 (taikoma tik atliekų kodui 19 12 12)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.NOT_DANGEROUS
  },
  { id: 1111, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1112, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1121, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1141, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1211, R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1212, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1213, R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1231, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1241, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1242, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1251, R: 0.37, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1252, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1261, R: 0.05, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1271, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1281, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  {
    id: "1281 (taikoma tik atliekų kodui 19 01 12)",
    R: 0.23,
    D: 1,
    S: 1,
    type: WasteType.NOT_DANGEROUS
  },
  { id: 1311, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  { id: 1321, R: 1, D: 1, S: 1, type: WasteType.NOT_DANGEROUS },
  {
    id: "TS-01 (visiems, išskyrus 16 02 09*  ir 16 02 10*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-01 (16 02 09*)",
    R: 0.05,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-01 (16 02 10*)",
    R: 0.05,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-02 (13 02 08*)",
    R: 0.01,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-02 (13 03 10*)",
    R: 0.01,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  { id: "TS-03", R: 0.13, D: 2, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-04", R: 0.13, D: 1, S: 1, type: WasteType.DANGEROUS },
  {
    id: "TS-05 (visiems, išskyrus 16 02 11*  ir 20 01 23*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-05 (16 02 11*)",
    R: 0.05,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-05 (20 01 23*)",
    R: 0.05,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: TS_06_CODES,
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (09 01 11*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 01*)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 02*)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 04*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 06*)",
    R: 0.05,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 07*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 08*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 09*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 10*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 11*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 13*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 14*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 22*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 24*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 26*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 28*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 30*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 32*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (16 06 34*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (19 02 12*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (19 02 13*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (19 14 01*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (19 14 02*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (19 14 03*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (19 14 04*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (19 14 05*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (19 14 06*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (19 14 07*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (20 01 33*)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS,
    deactivateOn: TS_06_DEACTIVATION_DATE
  },
  {
    id: "TS-06 (20 01 42*)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-06 (20 01 43*)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  { id: "TS-07", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  {
    id: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  { id: "TS-09", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  {
    id: "TS-10 (visiems, išskyrus 16 01 04*; 16 01 07*; 16 01 21*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-10 (16 01 04*)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-10 (16 01 07*)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-10 ( 16 01 21*)",
    R: 0.01,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  { id: "TS-11", R: 0.05, D: 0.52, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-12", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  {
    id: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-13 (16 06 03*)",
    R: 0.05,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-13 (20 01 21*)",
    R: 0.05,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  { id: "TS-14", R: 1, D: 2, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-15", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-16", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-17", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-18", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-19", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-20", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  {
    id: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-21 (16 02 12*)",
    R: 0.05,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-22 (07 01 04* )",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-22 (07 02 04*)",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-22 (07 03 04*)",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-22 (07 06 04*)",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-22 (07 07 04*)",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-22 (14 06 03*)",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-22 (14 06 05*)",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-22 (20 01 13*)",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-24 (taikoma visiems šio srauto atliekų kodams)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-25 (taikoma visiems šio srauto atliekų kodams)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  { id: "TS-26", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  {
    id: "TS-27 (taikoma visiems šio srauto atliekų kodams)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  { id: "TS-28", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS },
  {
    id: "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (05 01 02*)",
    R: 0.05,
    D: 2,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (04 02 19*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (05 01 09*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (06 05 02*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (07 01 11*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (07 02 11*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (07 03 11*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (07 04 11*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (07 05 11*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (07 06 11*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (07 07 11*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (10 01 20*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (10 01 22*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (11 01 09*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (17 05 05*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (19 08 11*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (19 08 13*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (19 13 03*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-29 (19 13 05*)",
    R: 0.15,
    D: 0.52,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-31 (03 01 04*)",
    R: 0.05,
    D: 0.69,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-31 (17 01 06*)",
    R: 0.05,
    D: 0.69,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-31 (17 02 04*)",
    R: 0.05,
    D: 0.69,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-31 (17 04 10*)",
    R: 0.05,
    D: 0.69,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-31 (17 05 03*)",
    R: 0.05,
    D: 0.69,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-31 (17 09 03*)",
    R: 0.05,
    D: 0.69,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-31 (19 02 04*)",
    R: 0.05,
    D: 0.69,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-31 (19 12 11*)",
    R: 0.01,
    D: 0.69,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-32 (visiems, išskyrus 11 01 11*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-32 (11 01 11*)",
    R: 0.52,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-33 (taikoma visiems šio srauto atliekų kodams)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-34 (taikoma visiems šio srauto atliekų kodams)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-35 (taikoma visiems šio srauto atliekų kodams)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  {
    id: "TS-36 (visiems, išskyrus 08 04 17*)",
    R: 1,
    D: 1,
    S: 1,
    type: WasteType.DANGEROUS
  },
  { id: "TS-36 (08 04 17*)", R: 1, D: 2, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-37", R: 1, D: 0.52, S: 1, type: WasteType.DANGEROUS },
  { id: "TS-38", R: 1, D: 1, S: 1, type: WasteType.DANGEROUS }
];

export const waste: WasteItem[] = [
  { streamId: "0122", id: "03 03 09", type: WasteType.NOT_DANGEROUS },
  { streamId: "0122", id: "11 01 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0124", id: "05 01 16", type: WasteType.NOT_DANGEROUS },
  { streamId: "0124", id: "05 07 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0124", id: "06 03 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0124", id: "06 03 16", type: WasteType.NOT_DANGEROUS },
  { streamId: "0124", id: "06 06 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0124", id: "11 02 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0141", id: "16 08 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0141", id: "16 08 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0141", id: "16 08 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0211", id: "02 01 09", type: WasteType.NOT_DANGEROUS },
  { streamId: "0212", id: "07 05 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0212", id: "18 01 09", type: WasteType.NOT_DANGEROUS },
  { streamId: "0212", id: "18 02 08", type: WasteType.NOT_DANGEROUS },
  { streamId: "0212", id: "20 01 32", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "04 02 17", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 01 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 01 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 01 16", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 01 18", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 01 20", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 02 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 03 07", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 03 08", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 03 13", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 03 15", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 03 18", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 04 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 04 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 04 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "08 04 16", type: WasteType.NOT_DANGEROUS },
  { streamId: "0213", id: "20 01 28", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "02 07 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "03 02 99", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "04 01 09", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "04 02 15", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "07 02 15", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "07 02 17", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "10 09 16", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "10 10 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "10 10 16", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "16 01 15", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "16 05 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "18 01 07", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "18 02 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "20 01 30", type: WasteType.NOT_DANGEROUS },
  { streamId: "0214", id: "20 01 33", type: WasteType.NOT_DANGEROUS },
  { streamId: "0231", id: "16 05 09", type: WasteType.NOT_DANGEROUS },
  { streamId: "0311", id: "05 01 17", type: WasteType.NOT_DANGEROUS },
  { streamId: "0311", id: "06 13 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0311", id: "10 01 25", type: WasteType.NOT_DANGEROUS },
  { streamId: "0311", id: "10 03 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0311", id: "10 03 18", type: WasteType.NOT_DANGEROUS },
  { streamId: "0311", id: "10 08 13", type: WasteType.NOT_DANGEROUS },
  { streamId: "0311", id: "10 08 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0311", id: "11 02 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0311", id: "20 01 41", type: WasteType.NOT_DANGEROUS },
  { streamId: "0313", id: "03 03 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0313", id: "04 01 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0313", id: "04 01 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0313", id: "11 01 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0314", id: "15 02 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0314", id: "19 09 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0314", id: "19 09 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0314", id: "19 09 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0314", id: "19 09 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "03 03 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "03 03 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "04 01 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "04 01 07", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "04 02 20", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "05 01 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "05 01 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "05 06 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "06 05 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "07 01 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "07 02 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "07 03 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "07 04 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "07 05 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "07 06 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "07 07 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 01 21", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 01 23", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 01 26", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 02 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 02 15", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 03 28", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 04 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 05 09", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 06 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 07 08", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 08 20", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 11 20", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "10 12 13", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "11 01 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "12 01 15", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "16 10 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "16 10 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "19 08 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "19 08 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "19 13 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "19 13 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0321", id: "19 13 08", type: WasteType.NOT_DANGEROUS },
  { streamId: "0331", id: "19 02 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0331", id: "19 04 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0331", id: "19 06 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0331", id: "19 06 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0331", id: "19 06 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0331", id: "19 06 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0331", id: "19 07 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0331", id: "19 11 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0521", id: "18 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0521", id: "18 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0521", id: "18 01 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0522", id: "18 02 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0522", id: "18 02 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0611", id: "10 02 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0611", id: "10 12 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0611", id: "12 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0611", id: "12 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0611", id: "16 01 17", type: WasteType.NOT_DANGEROUS },
  { streamId: "0611", id: "17 04 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0611", id: "19 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0611", id: "19 10 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0611", id: "19 12 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0623", id: "17 04 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0624", id: "17 04 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0625", id: "17 04 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0626", id: "11 05 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0626", id: "12 01 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0626", id: "12 01 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0626", id: "16 01 18", type: WasteType.NOT_DANGEROUS },
  { streamId: "0626", id: "17 04 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0626", id: "17 04 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0626", id: "17 04 11", type: WasteType.NOT_DANGEROUS },
  { streamId: "0626", id: "19 10 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0626", id: "19 12 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0631", id: "15 01 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0632", id: "02 01 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0632", id: "17 04 07", type: WasteType.NOT_DANGEROUS },
  { streamId: "0632", id: "20 01 40", type: WasteType.NOT_DANGEROUS },
  { streamId: "0711", id: "15 01 07", type: WasteType.NOT_DANGEROUS },
  { streamId: "0712", id: "10 11 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0712", id: "16 01 20", type: WasteType.NOT_DANGEROUS },
  { streamId: "0712", id: "17 02 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0712", id: "19 12 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0712", id: "20 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0721", id: "15 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0723", id: "19 12 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0723", id: "20 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0731", id: "16 01 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0741", id: "15 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0742", id: "02 01 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0742", id: "07 02 13", type: WasteType.NOT_DANGEROUS },
  { streamId: "0742", id: "12 01 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0742", id: "16 01 19", type: WasteType.NOT_DANGEROUS },
  { streamId: "0742", id: "17 02 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0742", id: "19 12 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0742", id: "20 01 39", type: WasteType.NOT_DANGEROUS },
  { streamId: "0751", id: "15 01 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0752", id: "03 01 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0753", id: "03 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0753", id: "03 03 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0753", id: "17 02 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0753", id: "19 12 07", type: WasteType.NOT_DANGEROUS },
  { streamId: "0753", id: "20 01 38", type: WasteType.NOT_DANGEROUS },
  { streamId: "0761", id: "20 01 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0762", id: "04 02 09", type: WasteType.NOT_DANGEROUS },
  { streamId: "0762", id: "04 02 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0762", id: "04 02 21", type: WasteType.NOT_DANGEROUS },
  { streamId: "0762", id: "04 02 22", type: WasteType.NOT_DANGEROUS },
  { streamId: "0762", id: "15 01 09", type: WasteType.NOT_DANGEROUS },
  { streamId: "0762", id: "19 12 08", type: WasteType.NOT_DANGEROUS },
  { streamId: "0762", id: "20 01 11", type: WasteType.NOT_DANGEROUS },
  { streamId: "0763", id: "04 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0763", id: "04 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0763", id: "04 01 08", type: WasteType.NOT_DANGEROUS },
  { streamId: "0812", id: "16 01 06", type: WasteType.NOT_DANGEROUS },
  { streamId: "0823", id: "09 01 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "0823", id: "09 01 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0823", id: "16 02 14", type: WasteType.NOT_DANGEROUS },
  { streamId: "0823", id: "20 01 36", type: WasteType.NOT_DANGEROUS },
  { streamId: "0841", id: "16 06 05", type: WasteType.NOT_DANGEROUS },
  { streamId: "0841", id: "20 01 34", type: WasteType.NOT_DANGEROUS },
  { streamId: "0841", id: "020 1 34", type: WasteType.NOT_DANGEROUS },
  { streamId: "0843", id: "16 01 12", type: WasteType.NOT_DANGEROUS },
  { streamId: "0843", id: "16 01 16", type: WasteType.NOT_DANGEROUS },
  { streamId: "0843", id: "16 01 22", type: WasteType.NOT_DANGEROUS },
  { streamId: "0843", id: "16 02 16", type: WasteType.NOT_DANGEROUS },
  { streamId: "0911", id: "02 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0911", id: "02 02 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0911", id: "02 02 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0911", id: "02 02 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0911", id: "02 05 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0912", id: "02 03 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0912", id: "02 06 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0912", id: "19 08 09", type: WasteType.NOT_DANGEROUS },
  { streamId: "0912", id: "20 01 08", type: WasteType.NOT_DANGEROUS },
  { streamId: "0912", id: "20 01 25", type: WasteType.NOT_DANGEROUS },
  { streamId: "0921", id: "02 01 07", type: WasteType.NOT_DANGEROUS },
  { streamId: "0921", id: "20 02 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0922", id: "02 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0922", id: "02 01 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0922", id: "02 03 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0922", id: "02 03 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "0922", id: "02 03 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0922", id: "02 06 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0922", id: "02 07 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "0922", id: "02 07 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "0922", id: "02 07 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "0931", id: "02 01 06", type: WasteType.NOT_DANGEROUS },
  { streamId: 1011, id: "20 03 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1011, id: "20 03 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1011, id: "20 03 07", type: WasteType.NOT_DANGEROUS },
  { streamId: 1011, id: "20 03 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1012, id: "20 03 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1021, id: "15 01 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1021, id: "15 01 06", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "01 03 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "01 04 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "01 05 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "02 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "02 02 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "02 03 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "02 04 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "02 05 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "02 06 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "02 07 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "03 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "03 03 07", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "03 03 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "03 03 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "04 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "04 02 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "05 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "05 06 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "05 07 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 02 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 03 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 04 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 06 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 07 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 08 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 09 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 10 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 11 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "06 13 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "07 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "07 02 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "07 03 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "07 04 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "07 05 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "07 06 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "07 07 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "08 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "08 02 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "08 03 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "08 04 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "09 01 07", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "09 01 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "09 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 02 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 03 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 04 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 05 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 06 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 07 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 08 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 09 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 10 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 11 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 12 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "10 13 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "11 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "11 02 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "11 05 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "12 01 13", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "12 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "16 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "16 03 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "16 03 06", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "16 07 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "19 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "19 02 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "19 05 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "19 06 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "19 08 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "19 08 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "19 09 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "19 11 99", type: WasteType.NOT_DANGEROUS },
  { streamId: 1022, id: "20 01 99", type: WasteType.NOT_DANGEROUS },
  { streamId: "1032", id: "19 02 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "1032", id: "19 02 10", type: WasteType.NOT_DANGEROUS },
  { streamId: "1032", id: "19 05 01", type: WasteType.NOT_DANGEROUS },
  { streamId: "1032", id: "19 05 02", type: WasteType.NOT_DANGEROUS },
  { streamId: "1032", id: "19 05 03", type: WasteType.NOT_DANGEROUS },
  { streamId: "1032", id: "19 10 04", type: WasteType.NOT_DANGEROUS },
  { streamId: "1032", id: "19 10 06", type: WasteType.NOT_DANGEROUS },
  {
    streamId: "1032 (taikoma tik atliekų kodui 19 12 10)",
    id: "19 12 10",
    type: WasteType.NOT_DANGEROUS
  },
  {
    streamId: "1032 (taikoma tik atliekų kodui 19 12 12)",
    id: "19 12 12",
    type: WasteType.NOT_DANGEROUS
  },
  { streamId: 1111, id: "19 08 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1112, id: "02 02 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1112, id: "02 03 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1112, id: "02 04 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1112, id: "02 05 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1112, id: "02 06 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1112, id: "02 07 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1112, id: "03 03 11", type: WasteType.NOT_DANGEROUS },
  { streamId: 1121, id: "05 01 13", type: WasteType.NOT_DANGEROUS },
  { streamId: 1121, id: "19 09 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1141, id: "20 03 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1141, id: "20 03 06", type: WasteType.NOT_DANGEROUS },
  { streamId: 1211, id: "17 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1211, id: "17 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1211, id: "17 01 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1211, id: "17 01 07", type: WasteType.NOT_DANGEROUS },
  { streamId: 1211, id: "17 05 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1211, id: "17 08 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1212, id: "17 03 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1213, id: "17 06 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1213, id: "17 09 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 03 06", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 03 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 03 09", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 04 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 04 09", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 04 10", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 04 11", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 04 12", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 04 13", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 05 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 05 07", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "01 05 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "02 04 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "08 02 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "10 11 10", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "10 12 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "10 13 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "19 08 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "19 09 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "19 13 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1231, id: "20 02 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 01 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 01 07", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 01 19", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 02 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 02 14", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 03 20", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 03 24", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 03 26", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 07 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 07 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 08 16", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 08 18", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 09 10", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 10 10", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 11 16", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 11 18", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 12 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 12 10", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 13 07", type: WasteType.NOT_DANGEROUS },
  { streamId: 1241, id: "10 13 13", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "06 09 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 01 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 01 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 01 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 01 15", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 01 17", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 01 24", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 02 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 02 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 03 16", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 03 22", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 03 30", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 05 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 05 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 05 11", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 06 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 06 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 06 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 07 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 07 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 07 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 08 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 08 09", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 08 11", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 09 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 09 12", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 10 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 10 12", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "10 12 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1242, id: "11 05 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "02 04 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "06 09 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "06 11 01", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "08 02 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 03 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 09 14", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 11 03", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 11 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 11 14", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 12 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 12 12", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 13 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 13 06", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 13 10", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 13 11", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "10 13 14", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "12 01 17", type: WasteType.NOT_DANGEROUS },
  { streamId: 1251, id: "12 01 21", type: WasteType.NOT_DANGEROUS },
  { streamId: 1252, id: "10 09 06", type: WasteType.NOT_DANGEROUS },
  { streamId: 1252, id: "10 09 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1252, id: "10 10 06", type: WasteType.NOT_DANGEROUS },
  { streamId: 1252, id: "10 10 08", type: WasteType.NOT_DANGEROUS },
  { streamId: 1252, id: "16 11 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1252, id: "16 11 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1252, id: "16 11 06", type: WasteType.NOT_DANGEROUS },
  { streamId: 1261, id: "17 05 04", type: WasteType.NOT_DANGEROUS },
  { streamId: 1261, id: "20 02 02", type: WasteType.NOT_DANGEROUS },
  { streamId: 1271, id: "17 05 06", type: WasteType.NOT_DANGEROUS },
  {
    streamId: "1281 (taikoma tik atliekų kodui 19 01 12)",
    id: "19 01 12",
    type: WasteType.NOT_DANGEROUS
  },
  { streamId: 1281, id: "19 01 14", type: WasteType.NOT_DANGEROUS },
  { streamId: 1281, id: "19 01 16", type: WasteType.NOT_DANGEROUS },
  { streamId: 1281, id: "19 01 18", type: WasteType.NOT_DANGEROUS },
  { streamId: 1281, id: "19 01 19", type: WasteType.NOT_DANGEROUS },
  { streamId: 1281, id: "19 12 09", type: WasteType.NOT_DANGEROUS },
  { streamId: 1311, id: "19 03 05", type: WasteType.NOT_DANGEROUS },
  { streamId: 1311, id: "19 03 07", type: WasteType.NOT_DANGEROUS },
  { streamId: 1321, id: "19 04 01", type: WasteType.NOT_DANGEROUS },
  {
    streamId: "TS-01 (visiems, išskyrus 16 02 09*  ir 16 02 10*)",
    id: "13 01 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-01 (visiems, išskyrus 16 02 09*  ir 16 02 10*)",
    id: "13 03 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-01 (visiems, išskyrus 16 02 09*  ir 16 02 10*)",
    id: "16 01 09",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-01 (16 02 09*)", id: "16 02 09", type: WasteType.DANGEROUS },
  { streamId: "TS-01 (16 02 10*)", id: "16 02 10", type: WasteType.DANGEROUS },
  {
    streamId: "TS-01 (visiems, išskyrus 16 02 09*  ir 16 02 10*)",
    id: "17 09 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "05 01 12",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "08 03 19",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "12 01 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "12 01 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "12 01 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "12 01 12",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "12 01 18",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "12 01 19",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 01 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 01 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 01 11",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 01 12",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 01 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 02 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 02 06",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 02 07",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-02 (13 02 08*)", id: "13 02 08", type: WasteType.DANGEROUS },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 03 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 03 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 03 09",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-02 (13 03 10*)", id: "13 03 10", type: WasteType.DANGEROUS },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "16 07 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "19 02 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "19 08 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "20 01 26",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "12 01 06",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "12 01 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 01 04",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 01 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 02 04",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-02 (visiems, išskyrus 13 02 08* ir 13 03 10*)",
    id: "13 03 06",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-03", id: "01 05 05", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "05 01 03", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "05 01 04", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "05 01 05", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "05 01 06", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "05 01 07", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "05 01 08", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "05 01 15", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "05 06 01", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "05 06 03", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "10 02 11", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "10 03 27", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "10 04 09", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "10 05 08", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "10 06 09", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "10 07 07", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "12 01 14", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "13 05 01", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "13 05 02", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "13 05 03", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "13 05 08", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "13 08 01", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "13 08 99", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "15 02 02", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "16 07 09", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "17 05 07", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "19 11 01", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "19 11 02", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "19 11 04", type: WasteType.DANGEROUS },
  { streamId: "TS-03", id: "19 11 05", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "10 08 19", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "13 04 01", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "13 04 02", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "13 04 03", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "13 05 06", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "13 05 07", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "13 07 01", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "13 07 02", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "13 07 03", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "13 08 02", type: WasteType.DANGEROUS },
  { streamId: "TS-04", id: "19 11 03", type: WasteType.DANGEROUS },
  {
    streamId: "TS-05 (visiems, išskyrus 16 02 11*  ir 20 01 23*)",
    id: "14 06 01",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-05 (16 02 11*)", id: "16 02 11", type: WasteType.DANGEROUS },
  { streamId: "TS-05 (20 01 23*)", id: "20 01 23", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (09 01 11*)", id: "09 01 11", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 01*)", id: "16 06 01", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 02*)", id: "16 06 02", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 04*)", id: "16 06 04", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 06*)", id: "16 06 06", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 07*)", id: "16 06 07", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 08*)", id: "16 06 08", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 09*)", id: "16 06 09", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 10*)", id: "16 06 10", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 11*)", id: "16 06 11", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 13*)", id: "16 06 13", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 14*)", id: "16 06 14", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 22*)", id: "16 06 22", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 24*)", id: "16 06 24", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 26*)", id: "16 06 26", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 28*)", id: "16 06 28", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 30*)", id: "16 06 30", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 32*)", id: "16 06 32", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (16 06 34*)", id: "16 06 34", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (19 02 12*)", id: "19 02 12", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (19 02 13*)", id: "19 02 13", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (19 14 01*)", id: "19 14 01", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (19 14 02*)", id: "19 14 02", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (19 14 03*)", id: "19 14 03", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (19 14 04*)", id: "19 14 04", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (19 14 05*)", id: "19 14 05", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (19 14 06*)", id: "19 14 06", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (19 14 07*)", id: "19 14 07", type: WasteType.DANGEROUS },
  {
    streamId: "TS-06 (20 01 33*)",
    id: "20 01 33",
    type: WasteType.DANGEROUS,
    deactivateOn: TS_06_DEACTIVATION_DATE
  },
  { streamId: "TS-06 (20 01 42*)", id: "20 01 42", type: WasteType.DANGEROUS },
  { streamId: "TS-06 (20 01 43*)", id: "20 01 43", type: WasteType.DANGEROUS },
  { streamId: "TS-07", id: "18 01 03", type: WasteType.DANGEROUS },
  { streamId: "TS-07", id: "18 02 02", type: WasteType.DANGEROUS },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "07 05 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "07 05 04",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "07 05 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "07 05 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "18 01 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "18 02 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "20 01 31",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "07 05 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "07 05 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-08 (taikoma visiems šio srauto atliekų kodams)",
    id: "07 05 09",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-09", id: "16 09 01", type: WasteType.DANGEROUS },
  { streamId: "TS-09", id: "16 09 02", type: WasteType.DANGEROUS },
  { streamId: "TS-09", id: "16 09 03", type: WasteType.DANGEROUS },
  { streamId: "TS-09", id: "16 09 04", type: WasteType.DANGEROUS },
  { streamId: "TS-10 (16 01 04*)", id: "16 01 04", type: WasteType.DANGEROUS },
  { streamId: "TS-10 (16 01 07*)", id: "16 01 07", type: WasteType.DANGEROUS },
  {
    streamId: "TS-10 (visiems, išskyrus 16 01 04*; 16 01 07*; 16 01 21*)",
    id: "16 01 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-10 (visiems, išskyrus 16 01 04*; 16 01 07*; 16 01 21*)",
    id: "16 01 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-10 (visiems, išskyrus 16 01 04*; 16 01 07*; 16 01 21*)",
    id: "16 01 14",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-10 ( 16 01 21*)", id: "16 01 21", type: WasteType.DANGEROUS },
  { streamId: "TS-11", id: "16 02 13", type: WasteType.DANGEROUS },
  { streamId: "TS-11", id: "16 02 15", type: WasteType.DANGEROUS },
  { streamId: "TS-11", id: "20 01 35", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "04 02 16", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "06 03 13", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "06 03 15", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "06 04 03", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "06 04 05", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 04 03", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 04 04", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 04 05", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 04 06", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 05 03", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 05 05", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 06 03", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 06 06", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 08 08", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 11 11", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "10 12 11", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "11 01 15", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "11 05 03", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "11 05 04", type: WasteType.DANGEROUS },
  { streamId: "TS-12", id: "19 08 08", type: WasteType.DANGEROUS },
  {
    streamId: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    id: "05 07 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    id: "06 04 04",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    id: "06 07 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    id: "10 14 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    id: "16 01 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    id: "16 03 07",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-13 (16 06 03*)", id: "16 06 03", type: WasteType.DANGEROUS },
  {
    streamId: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    id: "17 09 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    id: "18 01 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-13 (visiems šio srauto atliekų kodams, išskyrus 16 06 03* ir 20 01 21*)",
    id: "19 03 08",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-13 (20 01 21*)", id: "20 01 21", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "02 01 08", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "06 13 01", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "07 04 01", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "07 04 04", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "07 04 08", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "07 04 10", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "20 01 19", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "07 04 03", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "07 04 07", type: WasteType.DANGEROUS },
  { streamId: "TS-14", id: "07 04 09", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "06 07 02", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 01 03", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 01 07", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 01 09", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 02 03", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 02 07", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 02 09", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 03 03", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 03 07", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 03 09", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 06 03", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 06 07", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 06 09", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 07 03", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 07 07", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "07 07 09", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "14 06 02", type: WasteType.DANGEROUS },
  { streamId: "TS-15", id: "14 06 04", type: WasteType.DANGEROUS },
  { streamId: "TS-16", id: "03 02 02", type: WasteType.DANGEROUS },
  { streamId: "TS-17", id: "03 02 01", type: WasteType.DANGEROUS },
  { streamId: "TS-17", id: "03 02 03", type: WasteType.DANGEROUS },
  { streamId: "TS-17", id: "03 02 04", type: WasteType.DANGEROUS },
  { streamId: "TS-17", id: "03 02 05", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "01 03 04", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "06 01 01", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "06 01 02", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "06 01 03", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "06 01 04", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "06 01 05", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "06 01 06", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "06 07 04", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "08 03 16", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "10 01 09", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "11 01 05", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "11 01 06", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "16 08 05", type: WasteType.DANGEROUS },
  { streamId: "TS-18", id: "20 01 14", type: WasteType.DANGEROUS },
  { streamId: "TS-19", id: "05 01 11", type: WasteType.DANGEROUS },
  { streamId: "TS-19", id: "06 02 01", type: WasteType.DANGEROUS },
  { streamId: "TS-19", id: "06 02 03", type: WasteType.DANGEROUS },
  { streamId: "TS-19", id: "06 02 04", type: WasteType.DANGEROUS },
  { streamId: "TS-19", id: "06 02 05", type: WasteType.DANGEROUS },
  { streamId: "TS-19", id: "11 01 07", type: WasteType.DANGEROUS },
  { streamId: "TS-19", id: "11 01 13", type: WasteType.DANGEROUS },
  { streamId: "TS-19", id: "20 01 15", type: WasteType.DANGEROUS },
  { streamId: "TS-20", id: "06 03 11", type: WasteType.DANGEROUS },
  { streamId: "TS-20", id: "11 03 01", type: WasteType.DANGEROUS },
  {
    streamId: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    id: "06 07 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    id: "06 13 04",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    id: "10 13 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    id: "10 13 12",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    id: "16 01 11",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-21 (16 02 12*)", id: "16 02 12", type: WasteType.DANGEROUS },
  {
    streamId: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    id: "17 06 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    id: "17 06 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    id: "17 06 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-21 (visiems šio srauto atliekų kodams, išskyrus 16 02 12*)",
    id: "17 08 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "04 01 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "04 02 14",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 01 01",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-22 (07 01 04* )", id: "07 01 04", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 01 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 01 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 02 01",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-22 (07 02 04*)", id: "07 02 04", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 02 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 02 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 03 01",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-22 (07 03 04*)", id: "07 03 04", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 03 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 03 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 06 01",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-22 (07 06 04*)", id: "07 06 04", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 06 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 06 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 07 01",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-22 (07 07 04*)", id: "07 07 04", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 07 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-22 (visiems šio srauto atliekų kodams, išskyrus 07 01 04*, 07 02 04*, 07 03 04*, 07 06 04*, 07 07 04*, 14 06 03*, 14 06 05*, 20 01 13*)",
    id: "07 07 10",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-22 (14 06 03*)", id: "14 06 03", type: WasteType.DANGEROUS },
  { streamId: "TS-22 (14 06 05*)", id: "14 06 05", type: WasteType.DANGEROUS },
  { streamId: "TS-22 (20 01 13*)", id: "20 01 13", type: WasteType.DANGEROUS },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 01 11",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 01 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 01 17",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 01 19",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 01 21",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 03 12",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 03 14",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 03 17",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 04 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 04 11",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 04 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 04 15",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-23 (taikoma visiems šio srauto atliekų kodams)",
    id: "20 01 27",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-24 (taikoma visiems šio srauto atliekų kodams)",
    id: "09 01 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-24 (taikoma visiems šio srauto atliekų kodams)",
    id: "09 01 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-24 (taikoma visiems šio srauto atliekų kodams)",
    id: "09 01 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-24 (taikoma visiems šio srauto atliekų kodams)",
    id: "09 01 04",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-24 (taikoma visiems šio srauto atliekų kodams)",
    id: "09 01 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-24 (taikoma visiems šio srauto atliekų kodams)",
    id: "09 01 06",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-24 (taikoma visiems šio srauto atliekų kodams)",
    id: "09 01 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-24 (taikoma visiems šio srauto atliekų kodams)",
    id: "20 01 17",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-25 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 03 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-25 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 03 15",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-26", id: "12 01 16", type: WasteType.DANGEROUS },
  { streamId: "TS-26", id: "16 04 01", type: WasteType.DANGEROUS },
  { streamId: "TS-26", id: "16 04 02", type: WasteType.DANGEROUS },
  { streamId: "TS-26", id: "16 04 03", type: WasteType.DANGEROUS },
  {
    streamId: "TS-27 (taikoma visiems šio srauto atliekų kodams)",
    id: "16 03 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-27 (taikoma visiems šio srauto atliekų kodams)",
    id: "16 03 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-27 (taikoma visiems šio srauto atliekų kodams)",
    id: "16 05 06",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-27 (taikoma visiems šio srauto atliekų kodams)",
    id: "16 05 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-27 (taikoma visiems šio srauto atliekų kodams)",
    id: "16 05 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-27 (taikoma visiems šio srauto atliekų kodams)",
    id: "18 01 06",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-27 (taikoma visiems šio srauto atliekų kodams)",
    id: "18 02 05",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-28", id: "19 01 05", type: WasteType.DANGEROUS },
  { streamId: "TS-28", id: "19 01 07", type: WasteType.DANGEROUS },
  { streamId: "TS-28", id: "19 01 15", type: WasteType.DANGEROUS },
  { streamId: "TS-28", id: "19 01 17", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "01 05 06",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-29 (04 02 19*)", id: "04 02 19", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (05 01 02*)", id: "05 01 02", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (05 01 09*)", id: "05 01 09", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (06 05 02*)", id: "06 05 02", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (07 01 11*)", id: "07 01 11", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (07 02 11*)", id: "07 02 11", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (07 03 11*)", id: "07 03 11", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (07 04 11*)", id: "07 04 11", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (07 05 11*)", id: "07 05 11", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (07 06 11*)", id: "07 06 11", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (07 07 11*)", id: "07 07 11", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "08 01 15",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-29 (10 01 20*)", id: "10 01 20", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (10 01 22*)", id: "10 01 22", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "10 02 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "10 03 25",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "10 04 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "10 05 06",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "10 06 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "10 08 17",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "10 11 17",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-29 (11 01 09*)", id: "11 01 09", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "11 02 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "11 03 02",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-29 (17 05 05*)", id: "17 05 05", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "19 02 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-29 (visiems, išskyrus 04 02 19*, 05 01 02*, 05 01 09*, 06 05 02*, 07 01 11*, 07 02 11*, 07 03 11*, 07 04 11*, 07 05 11*, 07 06 11*, 07 07 11*, 10 01 20*, 10 01 22*, 11 01 09*, 17 05 05*, 19 08 11*,  19 08 13*, 19 13 03*, 19 13 05*)",
    id: "19 08 07",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-29 (19 08 11*)", id: "19 08 11", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (19 08 13*)", id: "19 08 13", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (19 13 03*)", id: "19 13 03", type: WasteType.DANGEROUS },
  { streamId: "TS-29 (19 13 05*)", id: "19 13 05", type: WasteType.DANGEROUS },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "06 13 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 01 04",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 01 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 01 14",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 01 16",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 03 04",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 03 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 04 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 04 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 05 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "10 08 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "11 01 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "19 01 11",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "19 01 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-30 (taikoma visiems šio srauto atliekų kodams)",
    id: "19 04 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "01 03 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "01 03 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "01 03 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "01 04 07",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-31 (03 01 04*)", id: "03 01 04", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "01 03 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "06 06 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "06 09 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "06 10 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "07 02 14",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "07 04 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "07 05 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 01 18",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 02 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 03 19",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 03 21",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 03 23",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 03 29",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 08 15",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 09 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 09 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 09 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 09 11",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 09 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 10 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 10 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 10 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 10 11",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 10 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 11 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 11 13",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 11 15",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 11 19",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "10 12 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "11 02 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "11 02 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "12 01 20",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "15 01 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "15 01 11",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "16 08 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "16 08 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "16 11 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "16 11 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "16 11 05",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-31 (17 01 06*)", id: "17 01 06", type: WasteType.DANGEROUS },
  { streamId: "TS-31 (17 02 04*)", id: "17 02 04", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "17 04 09",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-31 (17 04 10*)", id: "17 04 10", type: WasteType.DANGEROUS },
  { streamId: "TS-31 (17 05 03*)", id: "17 05 03", type: WasteType.DANGEROUS },
  { streamId: "TS-31 (17 09 03*)", id: "17 09 03", type: WasteType.DANGEROUS },
  { streamId: "TS-31 (19 02 04*)", id: "19 02 04", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 02 09",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 02 11",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 03 04",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 03 06",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 04 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 10 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 10 05",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 11 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 12 06",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-31 (19 12 11*)", id: "19 12 11", type: WasteType.DANGEROUS },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "19 13 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId:
      "TS-31 (visiems, išskyrus 03 01 04*, 17 01 06*, 17 02 04*, 17 04 10*, 17 05 03*, 17 09 03*, 19 02 04*, 19 12 11*)",
    id: "20 01 37",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "10 09 15",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "10 10 15",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-32 (11 01 11*)", id: "11 01 11", type: WasteType.DANGEROUS },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "11 01 98",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "12 03 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "12 03 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "16 08 06",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "16 10 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "16 10 03",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "19 01 06",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "19 02 08",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "19 07 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "19 13 07",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-32 (visiems, išskyrus 11 01 11*)",
    id: "20 01 29",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-33 (taikoma visiems šio srauto atliekų kodams)",
    id: "06 13 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-33 (taikoma visiems šio srauto atliekų kodams)",
    id: "19 01 10",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-34 (taikoma visiems šio srauto atliekų kodams)",
    id: "06 08 02",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-34 (taikoma visiems šio srauto atliekų kodams)",
    id: "07 02 16",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-35 (taikoma visiems šio srauto atliekų kodams)",
    id: "08 05 01",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-36 (08 04 17*)", id: "08 04 17", type: WasteType.DANGEROUS },
  {
    streamId: "TS-36 (visiems, išskyrus 08 04 17*)",
    id: "10 03 17",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-36 (visiems, išskyrus 08 04 17*)",
    id: "10 08 12",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-36 (visiems, išskyrus 08 04 17*)",
    id: "17 03 01",
    type: WasteType.DANGEROUS
  },
  {
    streamId: "TS-36 (visiems, išskyrus 08 04 17*)",
    id: "17 03 03",
    type: WasteType.DANGEROUS
  },
  { streamId: "TS-37", id: "11 01 16", type: WasteType.DANGEROUS },
  { streamId: "TS-37", id: "19 08 06", type: WasteType.DANGEROUS },
  { streamId: "TS-38", id: "16 05 04", type: WasteType.DANGEROUS }
];
